<template>
  <div>
    <n-bar title="充值明细" :top="true" :on-click-home="home"/>
    <list-loading style="height: calc(100% - 85px);" ref="list" :data.sync="list" :page.sync="page"
                  :limit.sync="limit" :threshold="100" @loadlist="getOrderData">
      <div slot="list" style="display: flex;align-items: center;margin: 0 10px;padding: 7px 0;"
           v-for="(item, index) in list" :key="index">
        <div style="flex: 1.5;display: flex;flex-direction: column;justify-content: center;">
          <div>{{item.orderId}}</div>
          <div style="color: #9B9B9B;font-size: 12px;margin-top: 5px;">{{item.payTime}}</div>
        </div>
        <div style="flex: 1.5;display: flex;flex-direction: column;justify-content: center;">
          <nut-price :price="item.money" :decimalDigits="2" :needSymbol="true" :thousands="true"
                     style="zoom: 0.9;margin-bottom: 5px;text-align: center"/>
        </div>
        <div style="flex: 1;text-align: end">
          <span style="color: #1afa29;" v-if="item.paid == 1">充值成功</span>
          <nut-button v-else @click="pay(item)" small shape="circle">支付</nut-button>
        </div>
      </div>
    </list-loading>
    <pay v-model="payShow" :price="payData.money" :pay-price="payData.money"
         :pay-type="2" :data="payData" :show-balance="false" :show-card="false"></pay>
  </div>
</template>
<script>
/**
 * 充值记录
 */
export default {
  name: 'DeviceRechargeRecord',
  data () {
    return {
      page: 1,
      limit: 20,
      user: {},
      list: [],
      payShow: false,
      payData: {},
    }
  },
  mounted () {
    this.user = this.$api.user
    this.getOrderData()
  },
  methods: {
    home () {
      let deviceId = localStorage.getItem('deviceId')
      this.$router.push(`/device/DeviceUse?deviceId=${deviceId}`)
    },
    getOrderData () {
      this.$api.post({
        url: '/device/api/device/device-recharge-order/list',
        data: {
          merId: this.$api.merId,
          uid: this.user.uid,
          page: this.page,
          limit: this.limit
        }
      }).then(res => {
        this.$refs.list.setRes(res)
      })
    },
    pay (item) {
      item.agentId = this.$api.agentId
      this.payData = item
      this.payShow = true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/home/DeviceRechargeRecord.vue